import { Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class FullscreenService {

  constructor() {
  // constructor(@Inject(DOCUMENT) private document: Document) {
    // document.addEventListener("keydown", (e) => {
    //   if (e.key === "F11") {
    //     toggleFullScreen();
    //   }
    // }, false);

    // function toggleFullScreen() {
    //   if (!document.fullscreenElement) {
    //     document.documentElement.requestFullscreen();
    //   } else if (document.exitFullscreen) {
    //     document.exitFullscreen();
    //   }
    // }
   }
}
